'use strict';

/**
 * Quick Shop "Scroll" hint (.scroll-more, sticky at the bottom of .modal-float).
 * Shown while the image column is taller than the visible part of .modal-float, which is the scroll
 * container (100vh). Measured whenever either of them changes size: a single measurement right after the
 * images load can run while .modal-float is still hidden, or before videos / images reach their final
 * height, and would then leave the hint hidden for the whole session.
 */

// One ResizeObserver per modal, keyed by its (reused) .modal-float element
var observers = new window.WeakMap();

/**
 * @param {jQuery} $modal - Quick Shop / edit product modal
 * @returns {{float: HTMLElement, images: HTMLElement}} Scroll container and image column (either may be null)
 */
function getParts($modal) {
    var float = $modal.find('.modal-float').get(0) || null;
    var images = float
        ? float.querySelector('.quickview-desktop-carousel .carousel-inner') || float.querySelector('.primary-images')
        : null;

    return { float: float, images: images };
}

/**
 * Shows / hides the hint for the current sizes.
 * @param {jQuery} $modal - Quick Shop / edit product modal
 */
function update($modal) {
    var parts = getParts($modal);
    var needsScroll = !!(parts.float && parts.images)
        && parts.images.getBoundingClientRect().height > parts.float.clientHeight;

    $modal.find('.scroll-more').toggleClass('d-none', !needsScroll);
}

/**
 * Stops watching (the modal is closed, or its image column is about to be watched afresh).
 * @param {HTMLElement} float - .modal-float of the modal
 */
function unwatch(float) {
    var observer = float ? observers.get(float) : null;
    if (observer) {
        observer.disconnect();
        observers.delete(float);
    }
}

/**
 * Starts (or restarts, after the image column was replaced) watching the sizes, and updates now.
 * .modal-float is reused for every opening, so there is at most one observer per modal: a new call
 * replaces the previous observer, and closing the modal disconnects it.
 * @param {jQuery} $modal - Quick Shop / edit product modal
 */
function watch($modal) {
    var parts = getParts($modal);
    if (!parts.float) {
        return;
    }

    unwatch(parts.float);

    if (typeof window.ResizeObserver === 'function') {
        var frame = null;
        // Size changes arrive in bursts while the modal animates in and images load: one update per frame
        var observer = new window.ResizeObserver(function () {
            if (frame) return;
            frame = window.requestAnimationFrame(function () {
                frame = null;
                update($modal);
            });
        });
        observer.observe(parts.float);
        if (parts.images) {
            observer.observe(parts.images);
        }
        observers.set(parts.float, observer);

        $modal.off('hidden.bs.modal.scrollMore').one('hidden.bs.modal.scrollMore', function () {
            unwatch(parts.float);
        });
    }

    update($modal);
}

module.exports = {
    update: update,
    watch: watch
};
